import React from 'react'

const ErrorPage = () => {
  return (
    <div className='text-center text-[20px] text-[#818589] font-medium mt-10'>
      The user is an admin and has full access.
    </div>
  )
}

export default ErrorPage